import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { AgentDetails } from "../../agentlist/components/AgentDetails";
import { AgentGameList } from "../../agentlist/components/AgentGameList";
import { AgentModalEnum } from "../../agentlist/components/AgentList";
import "../../agentlist/components/agentList.css";
import { AgentLotteryList } from "../../agentlist/components/AgentLotteryList";
import { LinkTelegramDialog } from "../../agentlist/components/linkTelegram/LinkTelegramDialog";
import { ShareDialog } from "../../agentlist/components/ShareModal";
import { TopupAndWithdrawDialog } from "../../agentlist/components/TopupAndWithdrawDialog";
import Pagination from "../../common/Pagination";
import { MemberList } from "../../memberlist/components/MemberList";
import * as actions from "../redux/SearchAction";

export const SearchByUsername = () => {
  const intl = useIntl();
  const [searchName, setSearchName] = useState("");
  const [swalProps, setSwalProps] = useState({});
  const [showList, setShowList] = useState(false);
  const [selAgentId, setSelAgentId] = useState(null);
  const [selMemberId, setSelMemberId] = useState(null);
  const [modalOpen, setModalOpen] = useState();
  const [selUsername, setSelUsername] = useState(null);
  const [selNickname, setSelNickname] = useState(null);
  const [selBalance, setSelBalance] = useState(null);
  const [memberSettingPermission, setMemberSettingPermission] = useState("");
  const [agentSettingPermission, setAgentSettingPermission] = useState("");
  const [creditControlPermission, setCreditControlPermission] = useState("");
  const [memberBalancePermission, setMemberBalancePermission] = useState("");
  const [agentDetailsVisible, setAgentDetailsVisible] = useState(false);
  const [memberDetailsVisible, setMemberDetailsVisible] = useState(false);
  const [currentMemberPage, setCurrentMemberPage] = useState(0);
  const [agentLotteryVisible, setAgentLotteryVisible] = useState(false);
  const [fromSide, setFromSide] = useState("");
  const [pathfromSearch, setPathfromSearch] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchState = useSelector(({ search }) => search, shallowEqual);
  const isMM6MM = process.env.REACT_APP_PROJECT_ID === "mm6mm";

  useEffect(() => {
    if (location.state?.searchUsername) {
      const searchUsername = location.state.searchUsername;
      setSearchName(searchUsername);
      const queryParams = {
        action: "searchbyusername",
        searchusername: searchUsername,
        pagenum: currentMemberPage,
      };
      dispatch(actions.callSearchList(queryParams)).then((resp) => {
        resp = resp.data;
        if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        } else {
          setShowList(true);
        }
      });
    }
  }, [dispatch, location]);

  useEffect(() => {
    const storedUserPermission = JSON.parse(
      localStorage.getItem("permissions")
    );
    if (storedUserPermission) {
      storedUserPermission.forEach((permission) => {
        switch (permission.permissioncode) {
          case "membersetting":
            setMemberSettingPermission(permission.allow);
            break;
          case "agentsetting":
            setAgentSettingPermission(permission.allow);
            break;
          case "creditcontrol":
            setCreditControlPermission(permission.allow);
            break;
          case "memberbalancecontrol":
            setMemberBalancePermission(permission.allow);
            break;
          default:
            break;
        }
      });
    }
    return () => dispatch(actions.callSearchList());
  }, []);

  const handleSearch = (pagenum) => {
    const queryParams = {
      action: "searchbyusername",
      searchusername: searchName,
      pagenum: pagenum ?? 0,
    };
    dispatch(actions.callSearchList(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      } else {
        setShowList(true);
      }
    });
  };

  const handleVipChange = (e, memberId) => {
    const newVip = e.target.value;
    const queryParams = {
      action: "updatemembervip",
      memberid: memberId,
      viplevel: newVip,
    };
    dispatch(actions.updateMemberVip(queryParams)).then((resp) => {
      resp = resp.data;
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        handleSearch(0)
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "updateMemberVipSuccess" }),
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    }).catch((error) => {
      setSwalProps({
        show: true,
        icon: "error",
        title: intl.formatMessage({ id: "error" }),
        text: error.message,
      });
    });
  };

  const renderSearchResults = (list, type) => (
    <>
      <div className="buttonCss">{intl.formatMessage({ id: type })}</div>
      <div className="agent-container" style={{ overflowX: "auto" }}>
        <table className="agent-table">
          <thead className="agent-header">
            <tr>
              <th className="agent-cell hide-on-mobile">
                {intl.formatMessage({ id: "no" })}
              </th>
              <th className="agent-cell fixed-column">
                {intl.formatMessage({ id: "username" })}
              </th>
              <th className="agent-cell">
                {intl.formatMessage({ id: "nickname" })}
              </th>
              {type !== "agentList" && !isMM6MM &&
                searchState.searchLists?.telnoshow === "true" && (
                  <th className="agent-cell text-start">
                    {intl.formatMessage({ id: "phoneNo" })}
                  </th>
                )}
              {isMM6MM && (
                <th className="agent-cell">
                  {intl.formatMessage({ id: "status" })}
                </th>
              )}
              <th className="agent-cell text-end">
                {intl.formatMessage({ id: "balance" })}
              </th>
              <th className="agent-cell">
                {intl.formatMessage({ id: "status" })}
              </th>
              {type !== "agentList" && (
                <th className="agent-cell agent-col text-center">
                  {intl.formatMessage({ id: "vip" })}
                </th>
              )}
              <th className="agent-cell" style={{ width: "1px" }}>
                {intl.formatMessage({ id: "action" })}
              </th>
            </tr>
          </thead>
          <tbody className="agent-body">
            {list.length > 0 ? (
              list.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid rgb(175, 164, 164, 0.4)",
                  }}
                >
                  <td className="agent-cell hide-on-mobile col-1">
                    {index + 1}
                  </td>
                  <td className="agent-cell fixed-column">
                    {type === "agentList" ? (
                      <>
                        <button
                          className="buttonName"
                          onClick={() => {
                            navigate(`/accountList`, {
                              state: {
                                username: item.username,
                                agentId: item.agentid,
                                searchName: "yes",
                                searchUsername: searchName,
                              },
                            });
                          }}
                        >
                          {item.username}
                        </button>
                      </>
                    ) : (
                      <>{item.username}</>
                    )}
                  </td>
                  <td className="agent-cell">{item.nickname}</td>
                  {type !== "agentList" &&
                    searchState.searchLists?.telnoshow === "true" && !isMM6MM && (
                      <td className="agent-cell">{item.telno}</td>
                    )}
                  {isMM6MM && (
                    <td className="agent-cell">{item.status}</td>
                  )}
                  <td className="agent-cell text-end">{item.balance}</td>
                  <td className="agent-cell">{item.status}</td>
                  {type !== "agentList" && (
                    <td className="agent-cell"><select
                      className="dropdown"
                      onChange={(e) => handleVipChange(e, item.memberid)}
                      value={item.vip}
                    >
                      {searchState.searchLists?.memberVipLevelLists?.map(
                        (vip) => (
                          <option key={vip.viplevel} value={vip.viplevel}>
                            Level {vip.viplevel}
                          </option>
                        )
                      )}
                    </select></td>
                  )}
                  <td className="agent-cell agent-col text-center">
                    {item.ispasswordnew === "true" && (
                      <i
                        className="bi bi-share"
                        data-bs-toggle="modal"
                        data-bs-target={`#ShareModal`}
                        onClick={() => {
                          if (type === "agentList") {
                            setFromSide("agent");
                            setSelAgentId(item.agentid);
                          } else if (type === "memberList") {
                            setFromSide("member");
                            setSelMemberId(item.memberid);
                          }
                        }}
                      ></i>
                    )}
                  </td>
                  <td className="agent-cell d-flex">
                    {type === "agentList" ? (
                      <>
                        <button
                          className="btn btn-primary me-1"
                          style={{
                            backgroundColor: "#00FFFF",
                            borderColor: "#00FFFF",
                            color: "black",
                          }}
                          onClick={() => {
                            setModalOpen(AgentModalEnum.Detail);
                            setSelAgentId(item.agentid);
                            setAgentDetailsVisible(true);
                          }}
                        >
                          <i className="bi bi-exclamation-circle" />
                        </button>
                        {creditControlPermission === "true" && (
                          <>
                            <button
                              className="btn btn-primary me-1"
                              style={{
                                backgroundColor: "#00FF00",
                                borderColor: "#00FF00",
                                color: "black",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target="#TopupAndWithdrawModal"
                              onClick={() => {
                                setModalOpen(AgentModalEnum.TopupWithdraw);
                                setSelAgentId(item.agentid);
                                setSelUsername(item.username);
                                setSelNickname(item.nickname);
                                setSelBalance(item.balance);
                                setPathfromSearch("yes");
                              }}
                            >
                              <i className="bi bi-wallet2" />
                            </button>
                            <button
                              className="btn btn-primary me-1"
                              style={{
                                backgroundColor: "#FFFF00",
                                borderColor: "#FFFF00",
                                color: "black",
                              }}
                              data-bs-toggle="modal"
                              data-bs-target={`#GameListModal`}
                              onClick={() => {
                                setModalOpen(AgentModalEnum.GameList);
                                setSelAgentId(item.agentid);
                              }}
                            >
                              <i className="bi bi-list-ul" />
                            </button>
                          </>
                        )}

                        {/* <button
                          className="btn btn-primary"
                          style={{
                            backgroundColor: "#0080FF",
                            borderColor: "#0080FF",
                            color: "black",
                          }}
                          onClick={() => {
                            setSelUsername(item.username);
                            setSelAgentId(item.agentid);
                            setAgentFeeChargeVisible(true);
                          }}
                        >
                          <i className="bi bi-diagram-2" />
                        </button> */}
                        {agentSettingPermission === "true" && (
                          <button
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#0080FF",
                              borderColor: "#0080FF",
                              color: "black",
                            }}
                            onClick={() => {
                              setModalOpen(AgentModalEnum.Lottery);
                              setSelAgentId(item.agentid);
                              setAgentLotteryVisible(true);
                              setPathfromSearch("yes");
                            }}
                          >
                            <i className="bi bi-4-circle" />
                          </button>
                        )}
                      </>
                    ) : (
                      <>
                        <button
                          className="btn btn-primary me-1"
                          style={{
                            backgroundColor: "#00FFFF",
                            borderColor: "#00FFFF",
                            color: "black",
                          }}
                          onClick={() => {
                            setSelMemberId(item.memberid);
                            setMemberDetailsVisible(true);
                          }}
                        >
                          <i className="bi bi-exclamation-circle" />
                        </button>
                        <button
                          className="btn btn-primary me-1"
                          style={{
                            backgroundColor: "#00FF00",
                            borderColor: "#00FF00",
                            color: "black",
                          }}
                          onClick={() =>
                            navigate(`/memberList/gameList/${item.memberid}`, {
                              state: {
                                userName: item.username,
                                searchName: "yes",
                                searchUsername: searchName,
                                memberBalancePermission:
                                  memberBalancePermission,
                              },
                            })
                          }
                        >
                          <i className="bi bi-controller" />
                        </button>
                        <button
                          className="btn btn-primary me-1"
                          style={{
                            backgroundColor: "#FFFF00",
                            borderColor: "#FFFF00",
                            color: "black",
                          }}
                          onClick={() =>
                            navigate(
                              `/memberList/memberReport/${item.memberid}`,
                              {
                                state: {
                                  userName: item.username,
                                  searchName: "yes",
                                  searchUsername: searchName,
                                },
                              }
                            )
                          }
                        >
                          <i className="bi bi-clipboard2-data" />
                        </button>
                        <button
                          className="btn btn-primary me-1"
                          style={{
                            backgroundColor: "rgb(0, 128, 255)",
                            borderColor: "rgb(0, 128, 255)",
                            color: "black",
                          }}
                          data-bs-toggle="modal"
                          data-bs-target={`#LinkTelegramModal`}
                          onClick={() => {
                            setSelMemberId(item.memberid);
                          }}
                        >
                          <i className="bi bi-link-45deg" />
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">
                  <div className="no-record-wrapper">
                    <i className="bi bi-search fs-1 mb-3" />
                    <div className="text-font2">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );

  const handlePageClick1 = (pageNumber) => {
    handleSearch(pageNumber);
  };

  return (
    <div style={{ width: "95%", margin: "5px auto" }}>
      <div>
        <h2>{intl.formatMessage({ id: "searchUsername" })}</h2>
      </div>
      <SweetAlert2
        {...swalProps}
        customClass="custom-swal"
        onResolve={() => setSwalProps({})}
        backdrop={false}
      />
      <ShareDialog
        selAgentId={selAgentId}
        selMemberId={selMemberId}
        fromSide={fromSide}
      />
      <TopupAndWithdrawDialog
        setSwalProps={setSwalProps}
        pathfromSearch={pathfromSearch}
        searchName={searchName}
        selAgentId={
          modalOpen === AgentModalEnum.TopupWithdraw ? selAgentId : undefined
        }
        selUsername={selUsername}
        selNickname={selNickname}
        selBalance={selBalance}
        currentMemberPage={currentMemberPage}
      />
      <AgentDetails
        selAgentId={
          modalOpen === AgentModalEnum.Detail ? selAgentId : undefined
        }
        isAgentDetailsVisible={agentDetailsVisible}
        agentSettingPermission={agentSettingPermission}
        onClose={() => setAgentDetailsVisible(false)}
      />
      <AgentGameList
        selAgentId={
          modalOpen === AgentModalEnum.GameList ? selAgentId : undefined
        }
      />
      <MemberList
        selMemberId={selMemberId}
        isMemberDetailsVisible={memberDetailsVisible}
        memberSettingPermission={memberSettingPermission}
        onClose={() => setMemberDetailsVisible(false)}
      />
      {/* <AgentFeeChargeList
        setSwalProps={setSwalProps}
        selAgentId={selAgentId}
        isAgentFeeChargeVisible={agentFeeChargeVisible}
        selUsername={selUsername}
        onClose={() => setAgentFeeChargeVisible(false)}
      /> */}
      <AgentLotteryList
        setSwalProps={setSwalProps}
        selAgentId={
          modalOpen === AgentModalEnum.Lottery ? selAgentId : undefined
        }
        pathfromSearch={pathfromSearch}
        searchName={searchName}
        isAgentLotteryVisible={agentLotteryVisible}
        onClose={() => setAgentLotteryVisible(false)}
      />
      <LinkTelegramDialog selMemberId={selMemberId} />
      <div className="d-flex">
        <div style={{ width: "80%", marginRight: "5px" }}>
          <input
            name="searchName"
            type="text"
            className="form-control"
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            placeholder={intl.formatMessage({ id: "username" })}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
          />
        </div>
        <div>
          <button className="btn btn-primary" onClick={() => handleSearch()}>
            {intl.formatMessage({ id: "search" })}
          </button>
        </div>
      </div>
      {showList && (
        <div>
          {searchState.searchLists?.agentList?.agentLists ? (
            renderSearchResults(
              searchState.searchLists.agentList.agentLists,
              "agentList"
            )
          ) : (
            <Skeleton height="600px" className="w-100" />
          )}
          {searchState.searchLists?.memberList?.memberLists ? (
            renderSearchResults(
              searchState.searchLists.memberList.memberLists,
              "memberList"
            )
          ) : (
            <Skeleton height="600px" className="w-100" />
          )}
        </div>
      )}
      <Pagination
        totalPages={parseInt(
          searchState.searchLists?.memberList?.totalpage ?? "0"
        )}
        currentPage={currentMemberPage}
        onPageChange={(pageNumber) => {
          handlePageClick1(pageNumber);
        }}
      />
    </div>
  );
};
